<div class="card bg-dark-lighter text-white">
  <div class="card-header">
    {{'User Controller' | uppercase}}
    <button type="button" data-bs-toggle="modal" data-bs-target="#modalManageUser" (click)="addUser()" *ngIf="permission.allowUpdating">
      <i class="fa fa-plus"></i>
      Add User
    </button>
    <!-- <div class="card-title">
    </div> -->
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table rox-table table-bordered bg-dark">
        <thead>
          <tr>
            <th>№</th>
            <th>User Name</th>
            <th>Group</th>
            <th *ngIf="permission.allowUpdating"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users | paginate: { itemsPerPage: pageInfo.pageSize, currentPage: pageInfo.pageIndex }; let i = index">
            <td>{{i + 1}}</td>
            <td>{{user.username}}</td>
            <td>{{user.role}}</td>
            <td class="text-end" *ngIf="permission.allowUpdating">
              <a data-bs-toggle="modal" data-bs-target="#modalManageUser" (click)="editUser(i, user)">
                <i class="fa fa-pencil-square-o "></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="clearfix mt-15">
      <div class="pagination-wrapper">
        <pagination-controls
          (pageChange)="pageInfo.pageIndex = $event"
          autoHide="true"
          responsive="true"
          previousLabel="Prev"
          nextLabel="Next"
        >
        </pagination-controls>
      </div>
    </div>
  </div>
</div>

<!-- USER MODAL -->
<div class="modal fade fx-modal" id="modalManageUser" #modalUser>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="manageUserMode === 'Add'">Add User</h4>
        <h4 class="modal-title" *ngIf="manageUserMode === 'Edit'">Edit User</h4>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <form class="form form-horizontal" #form="ngForm" autocomplete="off">
          <!--  fake fields are a workaround for chrome/opera autofill getting the wrong fields -->
          <input id="username" style="display:none" type="text" name="fakeusernameremembered">
          <input id="password" style="display:none" type="password" name="fakepasswordremembered">
          <div class="row mb-3 mb-3">
            <label class="col-md-4 control-label required">Username:</label>
            <div class="col-md-6">
              <input type="text" name="username" class="form-control bg-dark"
                     [(ngModel)]="user.username"
                     #username="ngModel"
                     required autocomplete="nope"
                     [disabled]="manageUserMode === 'Edit'"/>
              <div class="error-wrapper" *ngIf="(showError && username.errors) || (username.invalid && (username.dirty || username.touched))">
                <small class="error error-message" [hidden]="!username.errors.required">Required.</small>
              </div>
            </div>
          </div>

          <div class="row mb-3 mb-3">
            <label class="col-md-4 control-label" [ngClass]="{'required': manageUserMode === 'Add'}">Password:</label>
            <div class="col-md-6">
              <input type="password" name="password" class="form-control bg-dark" [(ngModel)]="user.password" #password="ngModel" autocomplete="new-password" [required]="manageUserMode === 'Add'" />
              <div class="error-wrapper" *ngIf="(showError && password.errors) || (password.invalid && (password.dirty || password.touched))">
                <small class="error error-message" [hidden]="!password.errors.required">Required.</small>
              </div>
            </div>
          </div>
          <div class="row mb-3 mb-3" *ngIf="user.password || manageUserMode === 'Add'">
            <label class="col-md-4 control-label">Confirm Password:</label>
            <div class="col-md-6">
              <input type="password" name="confirmPassword" class="form-control bg-dark" [(ngModel)]="user.confirmPassword" #confirmPassword="ngModel" required />
              <div class="error-wrapper" *ngIf="(showError && user.password) || confirmPassword.dirty || confirmPassword.touched">
                <small class="error error-message" [hidden]="user.password === user.confirmPassword">Not match.</small>
              </div>
            </div>
          </div>

          <div class="row mb-3 mb-3">
            <label class="col-md-4 control-label required">Group:</label>
            <div class="col-md-6">
              <label class="select">
                <select class="form-control bg-dark" name="group" #group="ngModel" [(ngModel)]="user.groupId" required>
                  <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
                </select>
              </label>
              <div class="error-wrapper" *ngIf="(showError && group.errors) || (group.invalid && (group.dirty || group.touched))">
                <small class="error error-message" [hidden]="!group.errors.required">Required.</small>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer m-auto">
        <button type="button" class="btn btn-primary mw-120" (click)="save()">Save</button>
        <button type="button" class="btn btn-default mw-120" data-bs-dismiss="modal">Cancel</button>
      </div>

    </div>
  </div>
</div>
